import Service from "../Service"

const footer = {
  getFooter () {
    return Service.get(`/api/footer`)
  }
}

export default footer
